"use client";

import { useEffect, useState } from "react";
import { HomeLogoLink } from "@/components/navigation/home-logo-link";
import { cn } from "@/lib/utils";

export default function LandingNavLogo() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const update = () => setScrolled(window.scrollY > 0);
    update();
    window.addEventListener("scroll", update, { passive: true });
    return () => window.removeEventListener("scroll", update);
  }, []);

  return (
    <HomeLogoLink
      className={cn(
        "transition-[opacity,visibility] duration-200 ease-out",
        scrolled && "max-sm:invisible max-sm:opacity-0"
      )}
    />
  );
}
